<template>
    <div class="nav-menu no-print">
        <simplebar ref="scroll" class="white left-nav-menu">
            <ul class="nav nav-stacked">
                <RouterLink
                    v-for="route in menu"
                    :key="route.name"
                    tag="li"
                    :to="{ name: route.name }"
                    :class="{
                        active: isActive(route),
                    }"
                >
                    <a class="nav-link" @click="linkClick($event)">
                        <i
                            v-if="route.name === ROUTE_NAMES.DUTY_SELECTOR"
                            :data-tooltip="$t(route.name + '.title')"
                            :class="[
                                'nav-list-icon',
                                'with-tooltip',
                                'scrollable',
                                'icon-' + (dutySelector ? 'duty-selector-on' : 'duty-selector-off'),
                            ]"
                        ></i>
                        <i
                            v-else
                            :data-tooltip="$t(route.name + '.title')"
                            :class="[
                                'nav-list-icon',
                                'with-tooltip',
                                'scrollable',
                                'icon-' + (route.meta && route.meta.icon ? route.meta.icon : 'close'),
                            ]"
                        ></i>
                        <span>{{ $t(route.name + '.title') }}</span>
                        <button
                            v-if="route.name === ROUTE_NAMES.CHECK_IN && checkInLocationsQty"
                            class="btn-counter"
                            :title="checkInTitle"
                        >
                            {{ checkInLocationsQty }}
                        </button>
                    </a>
                </RouterLink>
                <RouterLink v-for="external in externals" :key="external.name" tag="li" :to="external.path">
                    <a class="nav-link with-tooltip scrollable" :data-tooltip="external.description">
                        <img
                            v-if="external.icon"
                            :src="external.icon"
                            class="nav-list-icon"
                            :alt="external.name"
                        />
                        <i v-else class="nav-list-icon icon-plugin"></i> <span>{{ external.name }}</span>
                    </a>
                </RouterLink>
                <hr />
                <li>
                    <a class="nav-link" href="#" @click.prevent="performLogout">
                        <i
                            class="icon-logout nav-list-icon with-tooltip scrollable"
                            :data-tooltip="$t('logout.title')"
                        ></i>
                        <span v-show="!collapsed">{{ $t('logout.title') }}</span>
                    </a>
                </li>
            </ul>
        </simplebar>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import simplebar from 'simplebar-vue';
import lowerFirst from 'lodash-es/lowerFirst';
import { ROUTE_NAMES } from '../../constants';
export default {
    components: {
        simplebar,
    },
    constants: {
        ROUTE_NAMES: ROUTE_NAMES,
    },

    props: {
        logout: {
            type: Function,
            required: true,
        },

        menu: {
            type: Array,
            required: true,
        },

        checkin: {
            type: Object,
            required: true,
        },

        collapsed: {
            type: Boolean,
            required: true,
        },

        externalsConfig: {
            type: Array,
            required: true,
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        dutySelector: {
            type: Boolean,
            required: false,
            default: false,
        },
    },

    data() {
        return {};
    },

    computed: {
        /**
         * Creates array of menu items configured in external.json
         * @returns {{name: string, path: string, description: string, icon: string}[]}
         */
        externals() {
            return (this.externalsConfig || []).map((v, i) => ({
                name: v.title,
                path: '/external/' + i,
                description: v.description || v.title,
                icon: v.icon,
            }));
        },

        checkInLocationsQty() {
            return this.checkin.locationsList.length;
        },

        checkInTitle() {
            return this.collapsed
                ? this.checkInLocationsQty +
                      ' ' +
                      lowerFirst(
                          this.$t('checkIn.notCheckedInTab.timeWindowLabel', {
                              beginTime: this.checkin.beginTime,
                              endTime: this.checkin.endTime,
                          })
                      )
                : this.$t('checkIn.notCheckedInTab.timeWindowLabel', {
                      beginTime: this.checkin.beginTime,
                      endTime: this.checkin.endTime,
                  });
        },
    },
    mounted() {
        this.correctTooltip();
        this.$refs.scroll.scrollElement.addEventListener('scroll', this.correctTooltip);
    },
    methods: {
        ...mapActions({
            clearMessages: 'popup/clearMessages',
        }),

        linkClick(e) {
            if (this.disabled) {
                e.preventDefault();
            }

            this.clearMessages();
        },

        correctTooltip() {
            document.documentElement.style.setProperty(
                '--scrollValue',
                this.$refs.scroll.scrollElement.scrollTop + 'px'
            );
        },

        isActive(route) {
            return this.$route.name && route.name === this.$route.name.split('.')[0];
        },

        performLogout() {
            this.clearMessages();
            this.logout();
        },
    },
};
</script>
